type BarcodeHistoryItem = Record<string, unknown>;

type BarcodeHistoryResponse = {
  type?: string;
  pallet?: BarcodeHistoryItem;
  manufactured_item?: BarcodeHistoryItem;
  barcode_histories?: unknown[];
};

const formatDecimal = (value: unknown, decimals = 2) =>
  Number.parseFloat(String(value)).toFixed(decimals);

/** Convert either backend item shape into the single UI product shape. */
export function mapBarcodeHistoryProduct(data: BarcodeHistoryResponse) {
  const isPallet = data.type === "pallet";
  const item = isPallet ? data.pallet : data.manufactured_item;

  if (!item) return null;

  return {
    ...item,
    itemType: isPallet ? "pallet" : "manufactured",
    on_hand_net_kg: formatDecimal(item.on_hand_net_kg),
    on_hand_piece_count: formatDecimal(item.on_hand_piece_count, 0),
    name: item.product_name,
    name_ch: item.product_name_ch,
    barcode_histories: data.barcode_histories ?? [],
    total_cartons: isPallet ? item.total_cartons : 1,
    label_image_zpl: item.label_image_zpl ?? "",
  };
}
